<template>
    <div>
        <v-expansion-panels class="mt-2" flat tile style="border: 1px solid #ddd;">
            <v-expansion-panel @click="loadIframe = true">
                
                <v-expansion-panel-header disable-icon-rotate class="ma-0 pa-2">
                    <span :class="$vuetify.breakpoint.smAndDown ? 'font-weight-bold text-subtitle-1' : 'font-weight-bold text-h6'">Mapa</span>
                    <template v-slot:actions>
                        <span class="pa-2">Clique para visualizar</span>
                            <v-icon color="pink">
                                mdi-eye
                            </v-icon>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <iframe v-if="loadIframe" :src="map" height="450" width="100%" frameborder="0"></iframe>
                </v-expansion-panel-content>

            </v-expansion-panel>  
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
   props: {
        object: {
            required: true,
            default: () => ({})
        },
    }, 

    watch: {
        object: {
            handler(newVal) {
                // Atualiza o objeto local se o pai atualizar
                this.item = JSON.parse(JSON.stringify(newVal));
                this.map = 'https://maps.google.com/maps?q='+ this.item.latitude +',' + this.item.longitude +'&z=16&output=embed'  
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    data() {
        return {
            item: {},
            map: {},
            loadIframe: false
        }
    },
}
</script>

<style scoped>
.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 130px;
    width: 50%;
}
</style>